import React,{useState,useContext} from "react"
import DatePicker from "react-datepicker"
import TimeDisplay from './TimeDisplay'
import ClipLoader from "react-spinners/ClipLoader"
import EventsContext from '../contexts/EventsContext'
import ToggleButton from './ToggleButton'
import {getEventObject} from '../data-source/newEvents'
import moment from 'moment'
import "react-datepicker/dist/react-datepicker.css"


const nowMinuteAccuracy = () => {const now = new Date(); now.setSeconds(0); now.setMilliseconds(0); return now;}

const saveNewEvent = async (start,end,saveEventHandler,setLoading) => {
    console.log("Saving new event")
    setLoading(true)

    const event = getEventObject({
        start: moment(start).utc().format('YYYY-MM-DDTHH:mm:ss.000Z'),
        end: moment(end).utc().format('YYYY-MM-DDTHH:mm:ss.000Z')
    })

    console.log(event)

    await saveEventHandler(0,event)
    setLoading(false)
}

const ManualEvent = () => {
    const [startDate,setStartDate] = useState(nowMinuteAccuracy())
    const [endDate,setEndDate] = useState(nowMinuteAccuracy())
    const [loading,setLoading] = useState(false)
    const [panelOpen,setPanelOpen] = useState(false)
    const {saveEventHandler} = useContext(EventsContext)
    const hoursDuration = moment(endDate).diff(startDate,'hours',true)
    const panelId = 'manual_event_panel'
    return(
        <div class="card" style={{width: "100%", marginTop: "1rem"}}>
            <div class="card-header flex-row-space-between">
                <div>Add Manual Event</div>
                <div class="btn btn-outline-secondary "><ToggleButton id={panelId} openId={panelOpen ? panelId : ''} onClick={() => setPanelOpen(!panelOpen)}/></div>
            </div>
            <div class={`card-body toggle-element toggle-${panelOpen ? 'open' : 'closed'}`}>
                <div className="manual-event">
                    <span>From </span>
                    <span><DatePicker selected={startDate} onChange={setStartDate} showTimeSelect timeFormat="HH:mm" timeIntervals={5} dateFormat="MMMM d, yyyy HH:mm" timeCaption="Time"/></span>
                    <span> to </span>
                    <span><DatePicker selected={moment(endDate).isAfter(startDate) ? endDate : startDate} minDate={startDate} onChange={setEndDate} showTimeSelect timeFormat="HH:mm" timeIntervals={5} dateFormat="MMMM d, yyyy HH:mm" timeCaption="Time"/></span>
                    <span style={{minWidth: "7rem"}}><TimeDisplay decimalHours={hoursDuration}/></span>
                    <ClipLoader css={`display: inline-flex; vertical-align: middle; margin: 5px;`} size={30} loading={loading}/> 
                    <button type="button" className="btn btn-primary" onClick={() => saveNewEvent(startDate,endDate,saveEventHandler,setLoading)}>Add</button>
                </div>
            </div>
        </div>
        
    )
}

export default ManualEvent;